'use client';

import { ComponentProps } from 'react';

import { cn } from '@lib';

import { ThreeDee } from './3d';
import { Button } from './button';

export interface ActionBarProps extends React.ComponentProps<'div'> {
  actions: React.ComponentProps<typeof Button>[];
}

export const ActionBarWrapper = ({ children, className, ...rest }: ComponentProps<'div'>) => (
  <ThreeDee className={cn('to-card/90 flex items-center gap-1 p-1 backdrop-blur-lg', className)} {...rest}>
    {children}
  </ThreeDee>
);
